export const HANDLE_ERROR = '@flightBriefing/error/HANDLE_ERROR'
export const RESET_ERROR = '@flightBriefing/error/RESET_ERROR'


// WEBPACK FOOTER //
// ./src/shared/errorHandler/actions/types.js